package org.chiangmeng.qfast.core.domain.models

// Data model representing feature entitlements
data class ShopFeatures(
    val maxCategories: Int = 3,
    val allowCustomerDisplay: Boolean = false,
    val allowPrinter: Boolean = false
)

// Data model representing shop status and details
data class Shop(
    val id: String,
    val name: String,
    val currentServings: Map<String, Int>,
    val lastTicket: Int,
    val isActive: Boolean,
    val updatedAt: Long,
    val adText: String? = null,
    val menuUrl: String? = null,
    val openTime: String? = null,
    val closeTime: String? = null,
    val theme: String? = null,
    val categories: Map<String, String>? = null,
    val activeDeviceId: String? = null,
    val plan: String = "FREE"
) {
    val isPro: Boolean get() = plan == "PRO"
    val features: ShopFeatures get() = if (isPro) {
        ShopFeatures(
            maxCategories = 10,
            allowCustomerDisplay = true,
            allowPrinter = true
        )
    } else {
        ShopFeatures(
            maxCategories = 3,
            allowCustomerDisplay = false,
            allowPrinter = false
        )
    }
}
